import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import Spacer from "components/Spacer";
import PercentageIndicator from "components/visuals/PercentageIndicator";

import { selectors } from "modules/customer/insights/portfolio/performanceDrivers/staffing";

const SalesPerPoundOfStaffCostVariance = () => {
    const salesPerPoundOfStaffCostVariance = useSelector(state => selectors.salesPerPoundOfStaffCostVariance(state));
    const { loading, error, value } = salesPerPoundOfStaffCostVariance;
    const label = "% variance from median";

    return (
        <Box display="flex" data-cy="sales-per-pound-of-staff-cost-variance">
            <Typography variant="body1">{label}</Typography>
            <Spacer />
            <PercentageIndicator loading={loading} error={error} align="right" showIndicator={false} value={value} />
        </Box>
    );
};

export default SalesPerPoundOfStaffCostVariance;
